import { useEffect, useState } from 'react';
import { streamsApi } from '../api';
import './Streams.css';

function getPlatformUsername(stream) {
  switch (stream.platform) {
    case 'twitch': return stream.channel || null;
    case 'youtube': return stream.youtube_username || stream.youtube_channel || null;
    case 'tiktok': return stream.tiktok_username?.replace('@', '') || null;
    case 'kick': return stream.kick_username || stream.channel || null;
    default: return stream.channel || null;
  }
}

function Streams() {
  const [streams, setStreams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [copiedId, setCopiedId] = useState(null);

  const handleCopy = async (stream) => {
    const username = getPlatformUsername(stream);
    if (!username) return;
    try {
      await navigator.clipboard.writeText(username);
      setCopiedId(stream.id);
      setTimeout(() => setCopiedId(prev => (prev === stream.id ? null : prev)), 1500);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = username;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch {}
      document.body.removeChild(ta);
      setCopiedId(stream.id);
      setTimeout(() => setCopiedId(prev => (prev === stream.id ? null : prev)), 1500);
    }
  };

  useEffect(() => {
    streamsApi.getLive()
      .then(data => setStreams(data))
      .finally(() => setLoading(false));
  }, []);

  const getViewerCount = (stream) => {
    if (stream.platform === 'tiktok' && stream.tiktok_viewers) {
      return stream.tiktok_viewers;
    }
    return stream.peak_viewers || 0;
  };

  const getStreamUrl = (stream) => {
    if (stream.platform === 'tiktok' && stream.tiktok_link) return stream.tiktok_link;
    if (stream.platform === 'twitch' && stream.twitch_link) return stream.twitch_link;
    if (stream.platform === 'youtube' && stream.youtube_link) return stream.youtube_link;
    if (stream.platform === 'tiktok' && stream.tiktok_username) {
      return `https://www.tiktok.com/@${stream.tiktok_username.replace('@', '')}/live`;
    }
    if (stream.platform === 'twitch' && stream.channel) {
      return `https://www.twitch.tv/${stream.channel}`;
    }
    return null;
  };

  const getPlatformIcon = (platform) => {
    switch (platform) {
      case 'twitch': return '🟣';
      case 'youtube': return '🔴';
      case 'tiktok': return '⚫';
      case 'kick': return '🟢';
      default: return '📺';
    }
  };

  if (loading) {
    return (
      <div className="page">
        <div className="loading-container">
          <div className="spinner" />
          <p>Lädt...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page">
      <h1>Live Streams</h1>
      {streams.length === 0 ? (
        <p className="muted">Momentan keine Live-Streams.</p>
      ) : (
        <div className="streams-grid">
          {streams.map((stream) => {
            const streamUrl = getStreamUrl(stream);
            const viewers = getViewerCount(stream);
            const platformUsername = getPlatformUsername(stream);
            return (
              <div key={stream.id} className="stream-card">
                <div className="stream-info">
                  <h3>
                    {streamUrl ? (
                      <a href={streamUrl} target="_blank" rel="noreferrer" style={{ color: 'var(--accent-cyan)', textDecoration: 'none' }}>
                        {getPlatformIcon(stream.platform)} {stream.display_name || stream.username}
                      </a>
                    ) : (
                      <>{getPlatformIcon(stream.platform)} {stream.display_name || stream.username}</>
                    )}
                  </h3>
                  {platformUsername && (
                    <button
                      type="button"
                      onClick={() => handleCopy(stream)}
                      className="stream-username-btn"
                      title="Klicken zum Kopieren"
                    >
                      <span className="stream-username-label">@{platformUsername}</span>
                      <span className="stream-username-copy">{copiedId === stream.id ? '✓ Kopiert' : '📋'}</span>
                    </button>
                  )}
                  <p className="muted">
                    {stream.platform?.toUpperCase()}
                    {stream.tiktok_title && ` • ${stream.tiktok_title}`}
                  </p>
                  <span className="stream-viewers">👁 {viewers} Zuschauer</span>
                  {stream.vote_count > 0 && (
                    <span className="stream-votes" style={{ marginLeft: '12px', color: '#fbbf24' }}>★ {stream.vote_count} Votes</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default Streams;
